<div class="zc-container">
  <div class="grid">
    <div class="grid__s-12">
      <div [innerHTML]="useOfTermsPageContent"></div>
    </div>
  </div>
</div>
